export default __webpack_public_path__ + "static/media/BrainBreak cards8.36131bb8.png";